export const getPlansPath = '/planes';

export const getPlansQuotePath = '/planes/cotizaciones';

export const getClientPath = '/personas/busqueda';

export const validatePolizaPath = '/polizas/validacion';

export const cookiesPath = '/autenticacion-personas/cookies';

export const createQuotePath = '/cotizaciones';

export const validateSinisterPath = '/siniestros/validacion';

export const leadPath = '/leads/registrar';

export const addThirdPath = '/terceros';

export const validatePreExistingPath = '/preexistencias/validacion';

export const getDepartamentsPath = '/utilitarios/departamento/buscar';

export const getProvincesPath = '/utilitarios/provincia/buscar';

export const getDistrictsPath = '/utilitarios/distrito/buscar';

export const validateImcPath = '/imc/validacion';

export const planSelectionPath = '/planes/seleccion';

export const sessionPath = '/pagos/sesiones';

export const registerDpsPath = '/dps';

export const validateSubscription = '/validar/suscripcion';

export const susDpsPath = '/suscripciones';

export const dpsUploadPath = '/dps/subida';

export const dpsRoutePath = '/dps/rutas';

export const sendNotificationPath = '/notificaciones/envio';

export const sendEmailPath = '/utilitarios/correo/enviar';

export const calculatePath = '/descuentos/calculo';

export const getClientVCPath = '/tercero/obtener';

export const validateClientVCPath = '/tercero/validar';

export const sendEmisionPath = '/flujos-web/emisiones/trigger';
